// Meoks: Beden Kılavuzu modal — tablo render
(function () {
  function bind(modal) {
    if (modal.dataset.inited) return;
    if (modal.parentNode !== document.body) {
      // Önceki body-level instance'ları kaldır (duplicates önle)
      document.querySelectorAll('body > [data-meoks-guide-modal]').forEach(function (old) {
        if (old !== modal) old.remove();
      });
      document.body.appendChild(modal);
    }
    modal.dataset.inited = '1';

    document.querySelectorAll('[data-meoks-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        render(modal);
        modal.hidden = false;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('meoks-sf-open');
      });
    });
    modal.querySelectorAll('[data-meoks-guide-close]').forEach(function (c) {
      c.addEventListener('click', function () {
        modal.hidden = true;
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        document.body.classList.remove('meoks-sf-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        modal.hidden = true;
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        document.body.classList.remove('meoks-sf-open');
      }
    });
  }

  function render(modal) {
    var body = modal.querySelector('[data-meoks-guide-body]');
    var labels = [];
    var variants = [];
    var imageUrl = modal.getAttribute('data-olcu-image') || '';
    try { labels = JSON.parse(modal.getAttribute('data-olcu-labels') || '[]'); } catch (e) {}
    try { variants = JSON.parse(modal.getAttribute('data-variant-measurements') || '[]'); } catch (e) {}

    if (!labels.length || !variants.length) {
      body.innerHTML = '<p class="meoks-sf-hint" style="text-align:center;padding:20px 0;color:#888;">Bu ürün için henüz beden kılavuzu bilgisi girilmemiş.</p>';
      return;
    }

    var html = '';
    html += '<div class="meoks-sf-guide-table-wrap"><table class="meoks-sf-guide-table"><thead><tr><th>Beden</th>';
    labels.forEach(function (l) { html += '<th>' + l + ' (cm)</th>'; });
    html += '</tr></thead><tbody>';
    variants.forEach(function (v) {
      html += '<tr><td class="meoks-sf-guide-table__size">' + v.size + '</td>';
      labels.forEach(function (_, i) {
        var val = v.values && v.values[i] ? v.values[i] : '-';
        html += '<td>' + val + '</td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table></div>';
    if (imageUrl) {
      html += '<div class="meoks-sf-guide-image" style="margin-top:18px;"><img src="' + imageUrl + '" alt="Ölçü açıklamaları"></div>';
    }
    html += '<p class="meoks-sf-hint" style="margin-top:14px;">Ölçüler ürünün düz konumdayken alınmıştır. Üretim işlemi nedeniyle ölçüler küçük miktarda değişiklik gösterebilir.</p>';
    body.innerHTML = html;
  }

  function init() { document.querySelectorAll('[data-meoks-guide-modal]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var __p = false;
  new MutationObserver(function () {
    if (__p) return; __p = true;
    (window.requestIdleCallback || window.requestAnimationFrame)(function () { __p = false; init(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
